import { StratNodesReq, StratNodesDef } from "./type/strat-nodes-def";
import { DistributeReq, DistributeDef } from "./type/distribute-def";
import { InspectionReq, InspectionDef } from "./type/inspection-def";
import { RelevanceReq, RelevanceDef } from "./type/relevance-def";
import {
  SetStratBoundsReq,
  StratBoundsReq,
  StratBoundsDef,
} from "./type/strat-bounds-def";

import { StratBoundsAdapter } from "./adapter/strat-bounds-def";
import { StratNodesAdapter } from "./adapter/strat-nodes-def";
import { DistributeAdapter } from "./adapter/distribute-def";
import { InspectionAdapter } from "./adapter/inspection-def";
import { RelevanceAdapter } from "./adapter/relevance-def";


import { ICausalAiRepo } from "./irepo";

import { TError } from "../../types/error";

export class CausalAiUsecase {
  private repo: ICausalAiRepo;
  private error: (error: TError) => void;

  constructor(repo: ICausalAiRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async fetchRelevanceDef(req: RelevanceReq): Promise<RelevanceDef> {
    try {
      const dto = RelevanceAdapter.toInputDTO(req);
      const data = await this.repo.fetchRelevanceDef(dto);
      return RelevanceAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchStratNodesDef(req: StratNodesReq): Promise<StratNodesDef> {
    try {
      const dto = StratNodesAdapter.toInputDTO(req);
      const data = await this.repo.fetchStratNodesDef(dto);
      return StratNodesAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchStratBoundsDef(req: StratBoundsReq): Promise<StratBoundsDef> {
    try {
      const dto = StratBoundsAdapter.toInputDTO(req);
      const data = await this.repo.fetchStratBoundsDef(dto);
      return StratBoundsAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async setStratBoundsDef(req: SetStratBoundsReq): Promise<any> {
    try {
      const dto = StratBoundsAdapter.toUpdateInputDTO(req);
      const data = await this.repo.setStratBoundsDef(dto);
      return StratBoundsAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async deleteStratBoundsDef(req: StratBoundsReq): Promise<any> {
    try {
      const dto = StratBoundsAdapter.toInputDTO(req);
      const data = await this.repo.deleteStratBoundsDef(dto);
      return StratBoundsAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchDistributeDef(req: DistributeReq): Promise<DistributeDef> {
    try {
      const dto = DistributeAdapter.toInputDTO(req);
      const data = await this.repo.fetchDistributeDef(dto);
      return DistributeAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchInspectionDef(req: InspectionReq): Promise<InspectionDef> {
    try {
      const dto = InspectionAdapter.toInputDTO(req);
      const data = await this.repo.fetchInspectionDef(dto);
      return InspectionAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchBNModelList(): Promise<any[]> {
    return await this.repo.fetchBNModelList();
  }

  async fetchBNModelDetail(model_id: string): Promise<any> {
    return await this.repo.fetchBNModelDetail(model_id);
  }

}